import React from 'react';
import { connect } from 'react-redux';

class AgentSurvey extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        const {

        } = this.props;

        return (
            <>
                <div>
                    <div className="background">
                        <div className="white-box">
                            <br />
                            <div className="blue-boxes">
                                <div className="text">1. How Satisfied will the customer say they are will the service you've provided?</div>
                                <div className="parent-small-boxes">
                                    <div className="small-box-general small-box1">Very Satisfied <input className="checkbox1" type="radio" id="checkbox1" name="option" /></div>
                                    <div className="small-box-general small-box1">Somewhat Satisfied <input className="checkbox2" type="radio" id="checkbox2" name="option" /></div>
                                    <div className="small-box-general small-box1">Neutral<input className="checkbox3" type="radio" id="checkbox3" name="option" /></div>
                                    <div className="small-box-general small-box1">Somewhat Dissatisfied<input className="checkbox4" type="radio" id="checkbox4" name="option" /></div>
                                    <div className="small-box-general small-box1">Very Dissatisfied<input className="checkbox5" type="radio" id="checkbox5" name="option" /></div>
                                </div>
                            </div>
                            <div className="blue-boxes">
                                <div className="text">2. How Satisfied will the customer say they are with Zacoustic products?</div>
                                <div className="parent-small-boxes">
                                    <div className="small-box-general small-box1">Very Satisfied <input className="checkbox1" type="radio" id="checkbox1" name="option2" /></div>
                                    <div className="small-box-general small-box1">Somewhat Satisfied <input className="checkbox2" type="radio" id="checkbox2" name="option2" /></div>
                                    <div className="small-box-general small-box1">Neutral<input className="checkbox3" type="radio" id="checkbox3" name="option2" /></div>
                                    <div className="small-box-general small-box1">Somewhat Dissatisfied<input className="checkbox4" type="radio" id="checkbox4" name="option2" /></div>
                                    <div className="small-box-general small-box1">Very Dissatisfied<input className="checkbox5" type="radio" id="checkbox5" name="option2" /></div>
                                </div>
                            </div>
                            <div className="blue-boxes">
                                <div className="text">3. Will the customer tell us their issue is resolved?</div>
                                <div className="parent-small-boxes">
                                    <div className="small-box-general small-box1">Yes<input className="checkbox6" type="radio" id="checkbox6" name="option3" /></div>
                                    <div className="small-box-general small-box1">No<input className="checkbox7" type="radio" id="checkbox7" name="option3" /></div>
                                </div>
                            </div>
                            <br />
                            <div className="v3-button agent-view-interactions" style={{ marginLeft: '20px' }}>Submit</div>
                        </div>

                    </div>
                </div>
            </>
        )
    };
}

const select = state => ({ session: state.session });

export default connect(select)(AgentSurvey);
